<template>
  <div class="pay-selector">
    <c-action-sheet :visible.sync="inlineVisible">
      <div slot="title">选择支付方式</div>
      <div slot="menu">
        <c-cell-container class="item-cell-container mt-0" v-for="(configItem, key) in baseEpayment" :key="key">
          <c-cell-item :icon="configItem.icon" :title="configItem.name" :point="false" @click.native="selectPayType(configItem.type)">
            <i class="s-icon-arrow-right" slot="foot"></i>
          </c-cell-item>
        </c-cell-container>
        <!--<div class="share-row">-->
        <!--<div class="share-item" @click="selectPayType('alipay')">-->
        <!--<i class="s-icon-alipay"></i>-->
        <!--<span class="share-title">支付宝</span>-->
        <!--</div>-->
        <!--<div class="share-item" @click="selectPayType('wechatPay')">-->
        <!--<i class="s-icon-wechatpay-normal"></i>-->
        <!--<span class="share-title">微信</span>-->
        <!--</div>-->
        <!--</div>-->
      </div>
    </c-action-sheet>
  </div>
</template>
<style lang="scss" scoped>
  @import './index.scss';
</style>
<style lang="scss">
  @import "../../assets/scss/base/_mixin";
  
  .pay-selector .weui-actionsheet__title {
    height: px2rem(100px);
    text-align: left;
  }
  
  .pay-selector .item-cell-container .weui-cell {
    padding: px2rem(40px) px2rem(30px);
  }
  
  .item-cell-container.weui-cells:before {
    border-top: 0;
  }
  
  .item-cell-container.weui-cells:after {
    border-bottom: 0;
  }
</style>
<script>

  export default {
    name: 'pay-selector',
    data () {
      return {
        baseEpayment: [{
          icon: require('@/assets/images/setting/sales/alipay.png'),
          name: '支付宝',
          payType: 101,
          type: 'alipay'
        }, {
          icon: require('@/assets/images/setting/sales/weixin.png'),
          name: '微信',
          payType: 102,
          type: 'wechatPay'
        }]
      }
    },
    components: {},
    created () {
    },
    mounted () {
    },
    beforeDestroy () {
    },
    methods: {
      selectPayType (type) {
        if (!this.paySelectorPromise) return
        this.paySelectorPromise(type)
      }
    },
    computed: {
      inlineVisible: {
        get () {
          return this.$store.getters.getPaySelectorVisible
        },
        set (value) {
          if (!value) this.selectPayType('cancel')
          this.$store.commit('setPaySelectorVisible', value)
        }
      },
      paySelectorPromise () {
        return this.$store.getters.getPaySelectorPromise
      }
    },
    watch: {}
  }
</script>



// WEBPACK FOOTER //
// index.vue?51538ebe